module.exports = __webpack_public_path__ + "resources/img/img_dsm2_jp.c24406c02fd07c24fbb77a2f499de98e.png";